import { Link } from 'expo-router';
import { StyleSheet, View } from 'react-native';

import { Button, IconAdd, tokens } from '@fhs/ui';
import { ADD_MORE_ITEMS_BUTTON } from '@fhs-legacy/frontend/src/utils/test-ids';

export default function AddMoreItemsButton() {
  return (
    <View style={styles.container}>
      <Link href="/menu" asChild>
        <Button
          testID={ADD_MORE_ITEMS_BUTTON}
          size="md"
          type="outline-subtle"
          style={styles.button}
          accessibilityRole="button"
          accessibilityLabel="Add more items to cart"
          accessibilityHint="Navigates to the menu to add more items"
        >
          <Button.Icon>
            <IconAdd />
          </Button.Icon>
          <Button.Text>Add More Items</Button.Text>
        </Button>
      </Link>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 16,
    marginHorizontal: 16,
  },
  button: {
    width: '100%',
    color: tokens.colors.$houseDark,
  },
});
